import React from "react";
import { Card, Placeholder, Grid } from "semantic-ui-react";

const CardLoader = ({ numCards }) => {
  const numCardsPerRow = 4;
  const numRows = Math.ceil(numCards / numCardsPerRow);

  const renderSkeletons = () => {
    const skeletons = [];
    for (let i = 0; i < numRows; i++) {
      const cardsInRow = Math.min(
        numCards - i * numCardsPerRow,
        numCardsPerRow
      );
      skeletons.push(
        <Grid columns={4} stackable key={`row-${i}`}>
          {Array.from({ length: cardsInRow }).map((_, index) => (
            <Grid.Column key={`card-${i * numCardsPerRow + index}`}>
              <Card>
                <Card.Content>
                  <Placeholder fluid>
                    <Placeholder.Header>
                      <Placeholder.Line />
                    </Placeholder.Header>
                    <Placeholder.Paragraph>
                      <Placeholder.Line length="medium" />
                      <Placeholder.Line length="short" />
                    </Placeholder.Paragraph>
                  </Placeholder>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>
      );
    }
    return skeletons;
  };

  return <>{renderSkeletons()}</>;
};

export default CardLoader;
